import { getCurrentInstance, SetupContext, computed } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import Toast from 'vant/lib/toast';
import Cookies from 'js-cookie';
import { AIFeedLiked, AIFeed } from '@/api/ai-feed';
import { AIFeedPageEnum } from '@/store/modules/ai-feed';
import { AIActionType, AIActionBarProps } from './ai_common';
import { copyToClipboard } from '~/common/utils';
import { checkIfBomdiaApp } from '~/common/app';
import { UserInfoByLogin } from '~/api/user';
import AIChatLocalizeService from '~/pages/aichat/scripts/ai-chat';

/*
 * APP 环境的配置，social-ai暂时不需要
 */
// eslint-disable-next-line import/prefer-default-export
export const AIActionBarAppSetup = (props: AIActionBarProps, ctx: SetupContext<Array<'onChangeLoginPopupVisible'>>) => {
    // const baseSetup = ActionBarBaseSetup(props, ctx);
    const { proxy } = getCurrentInstance() || {};
    // const { feedList } = baseSetup || {};
    const feedList = computed<AIFeed[]>(() => {
        const { feedListOrigin } = proxy?.$store?.state?.feedMoudle || {};
        return feedListOrigin?.[props?.feedPage || AIFeedPageEnum.AIForyou] || [];
    });

    const userInfoByLogin = computed<UserInfoByLogin>(() => {
        const userInfoByLogin = (proxy?.$store?.state?.userModule?.userInfo || {}) as UserInfoByLogin;
        return userInfoByLogin;
    });

    // 暂时不需要 @xq
    const likeCount = (count: number) => {
        return (proxy?.$root?.$t('k_344306') || '') as string;
    };

    // 暂时不需要 @xq
    const shareCount = (count: number) => {
        return 'Share';
    };

    const { addLike, addUnlike, isBotLikedByUser } = AIChatLocalizeService();

    const handleLikeAction = debounce(async (type: AIActionType) => {
        const feedLikeStatus = type === AIActionType.Like ? AIFeedLiked.Like : AIFeedLiked.UnLike;
        props.aiFeed.liked = feedLikeStatus;
        const { user, userId, user_id } = userInfoByLogin.value || {};
        const uid = userId || user_id || user?.user_id || Cookies.get('userId');
        if (feedLikeStatus === AIFeedLiked.Like) {
            await addLike(props?.aiFeed);
        } else {
            await addUnlike(props?.aiFeed);
        }
    }, 300);

    const handleShareAction = debounce(async (url: string) => {
        copyToClipboard(url);
        Toast({
            message: proxy?.$root?.$t?.('k_446636'),
        });
    }, 300);

    const isShareButtonEnabled = computed(() => {
        if (checkIfBomdiaApp()) {
            return false;
        }

        return true;
    });

    const likeStatus = computed(() => {
        const res = isBotLikedByUser(props?.aiFeed);
        return res ? AIFeedLiked.UnLike : AIFeedLiked.Like;
    });

    return {
        handleLikeAction,
        handleShareAction,
        isShareButtonEnabled,
        likeStatus,

        likeCount,
        shareCount,
    };
};
